module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArIAAAABCAYAAAAiuE1yAAABIElEQVRIS+2UwQrDMAxDm+20///H/cWWIYjgIeI0vezUQIkry4rj2m3Hxuq9tw2aKBVvhhNb2TOfMe27trlX98c4Q3Fp612L+DP48tl/ZptnDfO5O4+Zj+dUGsRTK2PkF2Zd3VXvecfkpa79WfusJ3XJ5fm+t3NhD/D+7kf7/a3I57ejP2PZY+Z5JKjXR220s2+ZP7U5VtZlLM+qZkh4b629Nmf0pt0VuCuwqEDv/a2ZOo7jO+ZYNh9FJ1b5xf0MHenpqeLlk46Wbb0rPjHn53PFNy9jnAM1nYu59uUuTWOyeR5jGWftCrMOecznDPfdmdcs/8wj41hD1mbGy3uvvv+V3pj1jfuDfeKOdX94J3dls+MZu4OX09Jaq7T++o/5AT7FpwKkkHqmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/active/qrcode_title_white.png
// module id = Xs8L
// module chunks = 0